<template>
    <div class="row gx-2" :class="{loading: loading}" v-if="trigger > 0">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3" v-for="product in data">
            <ProductCard :product="product" />
        </div>
    </div>
</template>

<script>
import ProductCard from "../product/ProductCard";
export default {
    name: "ArchiveIndex",
    components: {ProductCard},
    computed: {
        data() {
            return this.$store.state.archive.data;
        },
        trigger() {
            return this.$store.state.archive.request.trigger;
        },
        loading() {
            return this.$store.state.archive.loading;
        }
    },
    watch: {
        trigger(value) {
            if (value > 0) {
                document.getElementById('archiveSsrProducts').style.display = 'none';
            }
        }
    }
}
</script>

<style scoped>

</style>
